export function extractYoutubeId(url: string): string | null {
  const match = url.match(/(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?|shorts)\/|.*[?&]v=)|youtu\.be\/)([^"&?/ ]{11})/);
  return match ? match[1] : null;
}

export function isYoutubeShort(url: string): boolean {
  return /youtube\.com\/shorts\//.test(url);
}

// Aceita instagram.com/p/X, /reel/X, /reels/X, /tv/X e o formato com usuário
// (instagram.com/usuario/reel/X); ignora query string (?igsh=...).
export function extractInstagramEmbedUrl(url: string): string | null {
  const match = url.match(/instagram\.com\/(?:[^/?#]+\/)?(p|reels?|tv)\/([A-Za-z0-9_-]+)/);
  if (!match) return null;
  const kind = match[1] === 'reels' ? 'reel' : match[1];
  return `https://www.instagram.com/${kind}/${match[2]}/embed`;
}
